import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage, isSupported } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyAemeN4wOALAZ6BykMtFOI4bjKoub4kR6Y",
  authDomain: "resipro-2471c.firebaseapp.com",
  projectId: "resipro-2471c",
  storageBucket: "resipro-2471c.firebasestorage.app",
  messagingSenderId: "283049167852",
  appId: "1:283049167852:web:cf049f1926442b68f20ec9",
  measurementId: "G-01PDEG2HJR"
 };

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Messaging with async check
let messaging;
(async () => {
  try {
    if (await isSupported()) {
      messaging = getMessaging(app);
    }
  } catch (error) {
    console.error('Firebase Messaging not supported', error);
  }
})();

// 
const VAPID_KEY = 'BA6vE_q5I0NUCAorkaYCI8QeZjK5lCAxrqL8WF_yGuIoiHK7HeQBeI0pPfZMq9QkBQnqcwQXw4Xuznrb07up6FI';

export const fetchToken = async (setTokenFound) => {
  try {
    if (!messaging) throw new Error('Messaging not initialized');
    
    // Request permission
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      setTokenFound?.(false);
      return null;
    }

    // Register service worker
    const swRegistration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
    
    // Get token
    const currentToken = await getToken(messaging, {
      vapidKey: VAPID_KEY,
      serviceWorkerRegistration: swRegistration
    });

    if (currentToken) {
      // Sanitize token
      const sanitizedToken = currentToken.replace(/['"\s]/g, '').trim();
      console.log('Sanitized FCM Token:', sanitizedToken);
  
      
      setTokenFound?.(true);
      return sanitizedToken;
    }

    setTokenFound?.(false);
    return null;

  } catch (error) {
    console.error('Token generation failed:', error);
    
    // Handle invalid tokens
    if (error?.code === 'messaging/invalid-registration-token') {
      // await deleteInvalidTokenFromBackend();
    }
    
    setTokenFound?.(false);
    return null;
  }
};


// export const fetchToken = (setTokenFound) => {
//   return getToken(messaging, {vapidKey: VAPID_KEY}).then((currentToken) => {
//     if (currentToken) {
//       // alert(currentToken);
//       console.log('current token for client: ', currentToken);
//       setTokenFound(true);
//       // Track the token -> client mapping, by sending to backend server
//       // show on the UI that permission is secured
//       return currentToken;
//     } else {
//       console.log('No registration token available. Request permission to generate one.');
//       setTokenFound(false);
//       // shows on the UI that permission is required 
//     }
//   }).catch((err) => {
//     console.log('An error occurred while retrieving token. ', err);
//     // catch error while creating client token
//   });
// }

// Token refresh handler
export const setupTokenRefresh = () => {
  if (!messaging) return;

  onMessage(messaging, (payload) => {
    console.log('Foreground message:', payload);
  });

  // token refresh
  const onTokenRefresh = async () => {
    try {
      const newToken = await getToken(messaging, { vapidKey: VAPID_KEY });
      if (newToken) {
        const sanitizedToken = newToken.replace(/['"\s]/g, '').trim();
        return sanitizedToken;
      }
    } catch (error) {
      console.error('Token refresh failed:', error);
    }
  };

  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data?.type === 'TOKEN_REFRESH_NEEDED') {
      onTokenRefresh();
    }
  });
};

// Message listener with Promise wrapper
export const onMessageListener = () =>
  new Promise((resolve) => {
    if (!messaging) return resolve(null);
    
    onMessage(messaging, (payload) => {
      console.log('Message received:', payload);
      resolve(payload);
    });
  });
